import React, { useState, useEffect } from 'react';

const CampaignCountdown = ({ endDate }) => {
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: false });
    
    useEffect(() => {
        if (!endDate) return;
        
        const calculateTimeLeft = () => {
            const now = new Date();
            const end = new Date(endDate);
            const diff = end - now;
            
            if (diff <= 0) {
                return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
            }
            
            return {
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((diff % (1000 * 60)) / 1000),
                expired: false
            };
        };
        
        setTimeLeft(calculateTimeLeft());
        const interval = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
        
        return () => clearInterval(interval);
    }, [endDate]);
    
    if (!endDate || timeLeft.expired) return null;
    
    // Compact format for badges
    const compactFormat = timeLeft.days > 0 
        ? `${timeLeft.days}g ${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}`
        : `${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;
    
    return (
        <div className="flex items-center gap-1 text-xs font-medium">
            <span>⏰</span>
            <span className="font-mono font-bold">
                {compactFormat}
            </span>
        </div>
    );
};

export default CampaignCountdown;

